export default __webpack_public_path__ + "static/media/Comp 2_00027.e7d9373e.png";